module.exports = __webpack_public_path__ + "img/spinner.1af2834a.gif";